<template>
    <el-dialog class="dialog-box" title="发起申请" v-if="outerForm" :visible.sync="outerForm" width="60%" top="5vh">
        <el-card class="box-card" shadow="never">
            <div slot="header" class="title-box">
                <span>发起人信息</span>
                <div class="tips">
                    <span>温馨提示：发起人信息必须先在我的信息中进行完善，否则无法进行申请</span>
                    <el-button type="primary" size="mini" icon="el-icon-thumb" style="margin-left:10px" @click="handleJump">去完善</el-button>
                </div>
            </div>

            <!-- 表格 -->
            <el-table class="grayTableTile" size="mini"  :data="tableList" border style="width: 100%">
                <el-table-column label="注册账号" min-width="120px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.username}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="真实姓名" min-width="90px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.realname}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="邮箱" min-width="130px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.email}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="所属公司" min-width="90px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.company}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="所属部门" min-width="90px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.department}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="职位" min-width="90px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.position}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 表单 -->
        <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
                <span>填写表单</span>
            </div>

            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
                <el-form-item label="是否代理申请：" prop="isApply">
                    <el-switch v-model="ruleForm.isApply"></el-switch>
                </el-form-item>

                <el-form-item label="申请平台：" >
                    <span v-if="isFile">美术平台</span>
                    <span v-if="isBdc">BDC平台</span>
                    <span v-if="isAds">ADS平台</span>
                    <span v-if="isGms">GMS平台</span>
                </el-form-item>

                <el-form-item label="申请游戏：" prop="appkeys" v-if="!isFile">
                    <el-select class="filter-item" size="small" v-model="ruleForm.appkeys" multiple collapse-tags filterable clearable placeholder="项目" style="width:300px;">
                        <el-option v-for="item in gameOptions" :key="item.appkey" :label="item.name" :value="item.appkey"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="申请原因：" prop="applyReason">
                    <el-input type="textarea" v-model="ruleForm.applyReason" rows="2" style="width: 300px"></el-input>
                </el-form-item>

            </el-form>
        </el-card>

        <!-- 被代理人信息 -->
        <el-card class="box-card" shadow="never" v-if="ruleForm.isApply">
            <div slot="header" class="title-box">
                <span>被代理人信息</span>
                <div class="tips">
                    <span>温馨提示：如代理申请，需被代理人先在bdc4.yingxiong.com官网进行账号注册并完善个人信息</span>
                </div>
            </div>
            
            <!-- 工具栏 -->
            <div class="filter-container">
                <!-- <el-select class="filter-item" size="small" v-model="users" placeholder="请输入代理用户的注册账号或者真实姓名进行搜索" multiple collapse-tags filterable remote reserve-keyword  :remote-method="getUsers"
    :loading="selectLoading" clearable style="width:360px;">
                    <el-option v-for="item in usersOptions" :key="item.id" :label="item.username" :value="item.id">
                        <span style="float: left">{{ item.username}}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px; margin-right:20px">{{ item.realname}}</span>
                    </el-option>
                </el-select> -->
                <el-input class="filter-item" size="small" v-model="userSearch" placeholder="请输入被代理用户的注册账号或者真实姓名进行搜索" style="width:360px;"></el-input>
                <el-button class="filter-item" size="small" type="primary" :loading="listLoading" @click="getUsers">添加</el-button>
            </div>

            <!-- 表格 -->
            <el-table size="mini" class="grayTableTile" v-loading="listLoading" :data="proxys" border style="width: 100%;">
                <el-table-column label="注册账号" min-width="120px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.username}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="真实姓名" min-width="90px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.realname}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="邮箱" min-width="130px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.email}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="所属公司" min-width="90px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.company}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="所属部门" min-width="90px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.department}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="职位" min-width="90px">
                    <template slot-scope="scope" >
                        <span>{{scope.row.position}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <div class="dialog-butn-box" style="margin: 0 20px 10px">
            <el-button size="small" type="primary" :loading="saveLoding" @click="handleSave('ruleForm')">提交申请</el-button>
            <el-button  size="small" @click="resetForm('ruleForm')">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { ajax_filterGame, ajax_authMerge, userfindByName } from '@Sys~/api/sys'
export default {
    data() {
        return {
            outerForm: false,
            
            // 表格
            listLoading: false,
            tableList: [],

            // 表单
            gameOptions:[],
            ruleForm: {
                isApply: false,
                appkeys: [],
                applyReason:''
            },
            rules: {
                isApply: [{ required: true, message: '请选择是否代理申请', trigger:['blur','change'] }],
                appkeys: [{ required: true, message: '请选择申请游戏', trigger: ['blur','change']}],
                applyReason: [{ required: true, message: '请输入申请原因', trigger: ['blur','change'] }],
            },

            // 代理人信息
            // users:[], // 已选代理人id
            // usersOptions:[],
            // selectLoading: false,

            userSearch:'', // 搜索人

            proxys:[], // 已选代理人信息

            saveLoding: false, // 申请loding

            isFile: process.env.VUE_APP_PROJECT_TYPE == 'file' ? true : false,
            isBdc: process.env.VUE_APP_PROJECT_TYPE == 'bdc' ? true : false,
            isAds: process.env.VUE_APP_PROJECT_TYPE == 'ads' ? true : false,
            isGms: process.env.VUE_APP_PROJECT_TYPE == 'gms' ? true : false
        }
    },

    computed:{
        ...mapGetters([
            'userInfo'
        ])
    },

    methods: {
        init() {
            this.outerForm = true
            this.listLoading = false
            this.tableList = []
            
            this.ruleForm = {
               isApply: false,
               appkeys: [],
               applyReason:''
            },

            this.saveLoding = false

            this.tableList = [
                {   
                    username: this.userInfo.username,
                    realname: this.userInfo.realname,
                    email: this.userInfo.email,
                    company: this.userInfo.attributes.company,
                    department: this.userInfo.attributes.department,
                    position: this.userInfo.attributes.position
                }
            ]

            // this.users = [], // 已选代理人id
            // this.usersOptions = [],
            // this.selectLoading = false
            this.userSearch = ''
            this.proxys = []

            this.getGameList() // 获取游戏列表
        },
        
        // 获取游戏列表
        getGameList() {
            ajax_filterGame().then(response => {
                if(response.code == 1) {
                    this.gameOptions = response.data
                }
            })
        },

        // 获取代理人信息
        getUsers() {
            if(this.userSearch !== '') {
                this.listLoading = true
                userfindByName(this.userSearch).then(response => {
                    this.listLoading = false
                    if(response.code == 1) {
                        this.proxys = response.data
                    }
                })
            }
        },

        // 删除用户
        handleDelete(index) {
            this.proxys.splice(index, 1);
        },

        // 添加代理人
        // handleAdd() {

        //     this.proxys = this.usersOptions.filter(item => {
        //         return this.users.indexOf(item.id) > -1
        //     })
        // },

        // 跳转 我的信息
        handleJump() {
            this.outerForm = false
            this.$router.push({path: '/gerenzhongxin'}) // 第一步个人中心页
        },

        // 确认 提交申请
        handleSave(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let applicants = []
                    if(this.ruleForm.isApply) {
                        if(this.proxys.length > 0) {
                            this.proxys.forEach(item => {
                                applicants.push(item.id)
                            })
                        } else {
                            this.$message({
                                message: '请添加代理人',
                                type: 'error'
                            });
                            return 
                        }
                    }

                    const data = {
                        applicants: this.ruleForm.isApply ? applicants : [this.userInfo.id],
                        appkeys: this.ruleForm.appkeys,
                        applyReason: this.ruleForm.applyReason,
                        type:process.env.VUE_APP_PROJECT_TYPE
                    }
                    this.saveLoding = true
                    ajax_authMerge(data).then(response => {
                        this.saveLoding = false
                        if(response.code == 1) {
                            this.$message({
                                message: '发起申请成功！',
                                type: 'success'
                            });
                            this.outerForm = false
                            this.$emit('reList')
                        }
                    })
                }
            })
        },

        // 取消
        resetForm(formName) {
            this.$refs[formName].resetFields(); 
            this.outerForm = false 
        }
    }
}
</script>

<style lang="scss" scoped>
    .title-box{
        display: flex;
        flex-flow: row wrap;
        justify-content: start;
        align-items: center;

        .tips{
            font-weight: normal;
            color: #F56C6C;
            font-size: 14px;
            margin: 0px 20px;
        }
    }

    .dialog-box{
         ::v-deep .el-dialog{
            height: auto;
            max-height: calc(100% - 10vh);
            overflow:auto;
        }
        ::v-deep .el-dialog__header{
            padding: 10px 10px 0;
            line-height: 30px;
            width: 60%;
            position: fixed;
            z-index: 99;
            background: #ffffff;
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        }
        ::v-deep .el-dialog__headerbtn{
            top: 10px;
        }
        ::v-deep .el-dialog__body{
            padding: 0 0 20px;
            margin-top: 40px;
        }
    }
    
    .box-card{
        border:none;
        ::v-deep .el-card__header{
            padding: 10px 30px;
            font-weight: bolder;
        }

        ::v-deep .el-select__tags{
            .el-tag {
                max-width: 84%;
                overflow: hidden;
                display: flex;
                flex-flow: row nowrap;
                justify-content: space-between;
                align-items: center;
                .el-select__tags-text{
                    width: 100%;
                    overflow: hidden;
                }
            }
            .el-select__input{
                margin-left: 2px;
            }
        }
    }
</style>